import React from 'react';
import UniversalCard from '../../../shared/UniversalCard';
import './WarningsCard.scss';

interface WarningsData {
  id: string;
  totalWarnings: number;
  debt: number;
  eviction: number;
}

interface WarningsCardProps {
  data?: WarningsData[];
  onWhyWarningClick?: () => void;
  onGetHelpClick?: () => void;
  className?: string;
}

// Моковые данные по умолчанию
const mockWarningsData: WarningsData[] = [
  {
    id: '2',
    totalWarnings: 2,
    debt: 1,
    eviction: 1
  }
];

// Иконка предупреждения
const warningIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9v4M12 17h.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Функция рендера содержимого карточки предупреждений
const renderWarningsContent = (
  item: any,
  index: number,
  onWhyWarningClick?: () => void,
  onGetHelpClick?: () => void
) => {
  const warnings = item as WarningsData;

  return (
    <>
      <div className="WarningsCard__number">
        {warnings.totalWarnings}
      </div>

      <div className="WarningsCard__substats">
        <div className="WarningsCard__column">
          <div className="WarningsCard__substat">
            <span className="WarningsCard__substat-label">Debt:</span>
            <span className="WarningsCard__substat-value">{warnings.debt}</span>
          </div>
        </div>

        <div className="WarningsCard__column">
          <div className="WarningsCard__substat">
            <span className="WarningsCard__substat-label">Eviction:</span>
            <span className="WarningsCard__substat-value">{warnings.eviction}</span>
          </div>
        </div>
      </div>

      <div className="WarningsCard__links">
        <div className="WarningsCard__link" onClick={onWhyWarningClick}>
          <div className="WarningsCard__link-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="7" stroke="#105E96"/>
              <path
                d="M8 11.5v-3.5M8 4.5h.01"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="WarningsCard__link-text">
            Why am I getting a warning?
          </span>
        </div>

        <div className="WarningsCard__link" onClick={onGetHelpClick}>
          <div className="WarningsCard__link-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 10.667C14 11.403 13.403 12 12.667 12H4.333L2 14V4.667C2 3.93 2.597 3.333 3.333 3.333H12.667C13.403 3.333 14 3.93 14 4.667V10.667Z"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="WarningsCard__link-text">
            Get help from our support
          </span>
        </div>
      </div>
    </>
  );
};

const WarningsCard: React.FC<WarningsCardProps> = ({
                                                     data,
                                                     onWhyWarningClick,
                                                     onGetHelpClick,
                                                     className = ''
                                                   }) => {
  const displayData = data || mockWarningsData;

  // Создаем функцию рендера с замыканием для передачи обработчиков
  const renderContent = (item: any, index: number) =>
    renderWarningsContent(item, index, onWhyWarningClick, onGetHelpClick);

  return (

      <UniversalCard
        title="Warnings"
        backgroundColor="#FB2F54"
        icon={warningIcon}
        data={displayData}
        renderContent={renderContent}
        className={className}
      />

  );
};

export default WarningsCard;